import { Action, Handler } from '../game';
import { SpecialAgain } from '../abilities';

export const recordPreviousAction: Handler = async ({ action, game }) => {
    if (action.command === undefined || action.is(SpecialAgain)) return;

    game.previous = action;
    return Action.incomplete();
};
